import { render, staticRenderFns } from "./DatiClinicoStrumRicoveroEdit.vue?vue&type=template&id=d1832214&scoped=true"
import script from "./DatiClinicoStrumRicoveroEdit.vue?vue&type=script&lang=js"
export * from "./DatiClinicoStrumRicoveroEdit.vue?vue&type=script&lang=js"
import style0 from "./DatiClinicoStrumRicoveroEdit.vue?vue&type=style&index=0&id=d1832214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1832214",
  null
  
)

export default component.exports